import './utils/forceLatinDigits';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './suppressWarnings';
import App from './app/App';
import { AuthProvider } from './app/providers/AuthContext';
import ErrorBoundary from './shared/components/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
// easter egg
window.next = {
  TeamIN: "Nope! not Next App XD",
}
// easter egg

root.render(
  <ErrorBoundary>
    <AuthProvider>
      <App />
    </AuthProvider>
  </ErrorBoundary>
); 